import * as React from 'react';

function SvgPassword(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={21.864} height={21.864} {...props}>
      <defs>
        <style>{`.password_svg__cls-1{fill:${props.fill}}`}</style>
      </defs>
      <g id="password_svg__password" transform="translate(0 -2040.004)">
        <g id="password_svg__Group_396" data-name="Group 396" transform="translate(0 2040.004)">
          <g id="password_svg__Group_395" data-name="Group 395">
            <circle
              id="password_svg__Ellipse_49"
              cx={0.854}
              cy={0.854}
              r={0.854}
              className="password_svg__cls-1"
              data-name="Ellipse 49"
              transform="translate(13.579 13.921)"
            />
            <path
              id="password_svg__Path_743"
              d="M10.163 2060.16H3.416a1.71 1.71 0 01-1.708-1.708v-7a1.71 1.71 0 011.708-1.708h12.3a1.71 1.71 0 011.708 1.708v1.708a.854.854 0 001.708 0v-1.708a3.42 3.42 0 00-3.416-3.416h-1.028v-3.012A5.077 5.077 0 009.564 2040a5.077 5.077 0 00-5.124 5.016v3.012H3.416a3.42 3.42 0 00-3.416 3.42v7a3.42 3.42 0 003.416 3.416h6.747a.854.854 0 100-1.708zm-4.016-15.14a3.367 3.367 0 013.416-3.308 3.367 3.367 0 013.416 3.308v3.012H6.148v-3.012z"
              className="password_svg__cls-1"
              data-name="Path 743"
              transform="translate(0 -2040.004)"
            />
            <path
              id="password_svg__Path_744"
              d="M996.671 3247.651a.854.854 0 00-1.192.2l-4.21 5.88a.488.488 0 01-.7.036l-2.721-2.655a.854.854 0 00-1.193 1.222l2.725 2.66.008.007a2.2 2.2 0 001.515.605h.145a2.2 2.2 0 001.566-.816l.029-.038 4.227-5.9a.854.854 0 00-.199-1.201z"
              className="password_svg__cls-1"
              data-name="Path 744"
              transform="translate(-975.164 -3233.741)"
            />
            <circle
              id="password_svg__Ellipse_50"
              cx={0.854}
              cy={0.854}
              r={0.854}
              className="password_svg__cls-1"
              data-name="Ellipse 50"
              transform="translate(10.334 13.921)"
            />
            <circle
              id="password_svg__Ellipse_51"
              cx={0.854}
              cy={0.854}
              r={0.854}
              className="password_svg__cls-1"
              data-name="Ellipse 51"
              transform="translate(3.929 13.921)"
            />
            <circle
              id="password_svg__Ellipse_52"
              cx={0.854}
              cy={0.854}
              r={0.854}
              className="password_svg__cls-1"
              data-name="Ellipse 52"
              transform="translate(7.131 13.921)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgPassword;
